<button
  type="button"
  class="btn btn-rounded btn-rounded-square ellipsis"
  [disabled]="disabled"
  (menuOpened)="onMenuOpened()"
  (menuClosed)="onMenuClosed()"
  [matMenuTriggerFor]="multiSelectMenu"
>
  @if (selectedSet.size === items.length) {
    All Categories
  } @else if (selectedSet.size > 1) {
    {{ selectedSet.size | i18nPlural: buttonText }}
  } @else if (selectedSet.size === 1) {
    {{ getSelectedCategoryName() }}
  } @else {
    Select Categories
  }
</button>

<mat-menu #multiSelectMenu="matMenu" class="menu-width-md">
  <ng-template matMenuContent="">
    <div *ngIf="hasSearch" class="menu-search mat-mdc-menu-item d-flex align-items-center shrink-0">
      <craft-icon class="svg-icon text-size-13 mr-10" name="search--search"></craft-icon>
      <input
        type="text"
        #searchInput
        (click)="$event.stopPropagation()"
        [placeholder]="searchPlaceholder"
        [formControl]="searchControl"
      />
    </div>
    <div class="menu-scroll">
      @for (item of filteredItems | async; track item.id) {
        <div mat-menu-item="" class="item-checkbox" (click)="selectItem(item, $event)" craftDisableFocus="">
          <mat-checkbox
            [checked]="selectedSet.has(item[idFieldName])"
            class="checkbox-black small"
            [title]="item[labelFieldName]"
          >
            {{ item[labelFieldName] }}
          </mat-checkbox>
        </div>
      }
    </div>

    <div class="dropdown-footer">
      <button (click)="setNullValue($event)" type="button" class="btn">Clear</button>
      <button (click)="selectAll($event)" type="button" class="btn">Select All</button>
    </div>
  </ng-template>
</mat-menu>
